import { Component } from '@angular/core';

import {EventEmitter, OnInit, Output } from '@angular/core';
import { IAuditTableQueryDto } from 'src/app/models/IAuditTableQueryDto';

@Component({
  selector: 'app-order-modal',
  templateUrl: './order-modal.component.html',
  styleUrls: ['./order-modal.component.css']
})
export class OrderModalComponent  implements OnInit {
  @Output() valueChange = new EventEmitter<boolean>();

  productVisible: boolean = false;
  products!: Product[];
  selectedProducts!: Product;
  showFilterModal:boolean = true;

  messages: any;
  errorMessage:any;


  girdShow: boolean = true;
  girdData() {
    this.girdShow = true;
  }
  girdDataEmpty() {
    this.girdShow = false;
  }

  ngOnInit() {
    this.productVisible = true;
  }


  onDialogHide() {
    this.valueChange.emit(true);
  }

  async applyFilter(event: any) {

    if (event.conditions[0].value) {
    this.messages = [{ severity: 'success', summary: 'Filter', detail: 'applied successfully' }];
    }
    else{

    this.errorMessage = [
      { severity: 'error', summary: 'Invalid query!', detail: 'Check your filter logic!' },
  ];
    }
  }


}

export interface Product {
  id?: string;
  code?: string;
  name?: string;
  description?: string;
  price?: number;
  quantity?: number;
  inventoryStatus?: string;
  category?: string;
  image?: string;
  rating?: number;
}

